<ng-container *ngIf='{timezone: (date|getTimezoneFromDateFromServer)} as obj'>
  <span *ngIf='type=="date"' class='o-{{typeText}}'>
    {{date ? (date|date:format:obj.timezone) : '-'}}
  </span>

  <span *ngIf='type=="time"' class='o-{{typeText}}'>
    {{date ? (date|date:format:obj.timezone) + ' ' + obj.timezone : '-'}}
  </span>
</ng-container>
